import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberOfficeHoursPage from "@/pages/member/MemberOfficeHoursPage";

export const Route = createFileRoute("/member/office-hours")({
  head: () => pageHead("Member · Office Hours", "AKIVA member · office hours portal.", "/member/office-hours", true),
  component: MemberOfficeHoursPage,
});
